import { z } from 'zod';
import { MAX_NEW_CONTACTS, MAX_NEW_CONTACTS_MESSAGE } from './constraints.js';
import { contactFormSchema } from './create-form.js';
import { isBlankContactForm } from './is-blank-contact-form.js';
import { refineSinglePrimaryContact } from './refine-single-primary-contact.js';
/** A new customer's or vendor's contact rows: a row left blank is skipped, and every other row must be a whole contact. */
export const newContactsFormSchema = z.object({
    contacts: z
        .array(z.custom())
        .max(MAX_NEW_CONTACTS, MAX_NEW_CONTACTS_MESSAGE)
        .superRefine((contacts, context) => {
        contacts.forEach((contact, index) => {
            if (isBlankContactForm(contact))
                return;
            for (const issue of contactFormSchema.safeParse(contact).error?.issues ?? []) {
                context.addIssue({
                    code: 'custom',
                    message: issue.message,
                    path: [index, ...issue.path],
                });
            }
        });
    })
        .superRefine(refineSinglePrimaryContact),
});
//# sourceMappingURL=new-contacts-form.js.map